module.exports = __webpack_public_path__ + "img/shutterstock_297265649.17983639.jpg";